import type { LucideIcon, LucideProps } from 'lucide-react'
import React, { forwardRef } from 'react'

import pointIcon from 'src/shared/assets/icons/utils/point-icon.png'

export const PointIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <image href={pointIcon} width="24" height="24" preserveAspectRatio="xMidYMid meet" />
    </svg>
  )
})

PointIcon.displayName = 'PointIcon'
